/**
 * Is the tab backgrounded? (perf cost-census, increment 2).
 *
 * The client had NO `visibilitychange` awareness anywhere — every `setInterval` and the WebAudio analysers
 * kept running at full rate in a hidden tab, draining a laptop's battery for work nobody can see. Purely-
 * VISUAL high-frequency timers (the self speaking-ring / level-meter / loudness-swell, the room chip, the
 * "press E to sit" prompt) call this and skip their body while hidden; the work resumes automatically the
 * next time the timer fires while visible (no re-arm needed).
 *
 * Deliberately scoped: inbound WebRTC audio playback and the connection keepalive (PING) are NOT gated
 * here, so a backgrounded tab still hears voice and stays connected — only the invisible recompute stops.
 * Guarded for non-DOM contexts (tests / SSR).
 */
export function isTabHidden(): boolean {
  return typeof document !== 'undefined' && document.hidden;
}
